import { Body, Controller, Delete, Get, HttpCode, Param, Post, Req, UseGuards } from '@nestjs/common';
import { AuthGuard, GuardedRequest } from '../auth/auth.guard';
import { PaymentMethodsService } from './payment-methods.service';
import { AddPaymentMethodRequest } from '@cart/shared-types';

@Controller('me/payment-methods')
@UseGuards(AuthGuard)
export class PaymentMethodsController {
  constructor(private readonly service: PaymentMethodsService) {}

  @Get()
  list(@Req() req: GuardedRequest) {
    return this.service.list(req.user.id);
  }

  @Post()
  add(@Body() dto: AddPaymentMethodRequest, @Req() req: GuardedRequest) {
    return this.service.add(req.user.id, dto);
  }

  @Delete(':id')
  @HttpCode(200)
  remove(@Param('id') id: string, @Req() req: GuardedRequest) {
    return this.service.remove(req.user.id, id);
  }
}
